"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionInsightProcessCtrl = void 0;
const i18n_1 = require("../../i18n");
const index_1 = require("../../services/index");
const page_state_1 = require("../../state/page.state");
const collection_insight_process_modal_1 = require("../collection.insight.process.modal/collection.insight.process.modal");
exports.CollectionInsightProcessCtrl = {
    canTriggerInsightProcessing(currentUser) {
        const userIsAbleToRequestInsightProcessing = 'isAbleToRequestInsightProcessing' in index_1.Services.User.current &&
            index_1.Services.User.current.isAbleToRequestInsightProcessing;
        return ((index_1.Services.UserProfile.isDepartmentAdmin(currentUser) ||
            index_1.Services.UserProfile.isDepartmentDataAdmin(currentUser)) &&
            userIsAbleToRequestInsightProcessing);
    },
    showInsightProcessModal() {
        const collections = page_state_1.CurrentState.Tag.collections;
        const modal = new collection_insight_process_modal_1.CollectionInsightProcessModal({
            title: i18n_1.T.COLLECTION_INSIGHT_PROCESS_TITLE,
            confirm: i18n_1.T.COLLECTION_INSIGHT_PROCESS,
            success: {
                key: i18n_1.T.COLLECTION_INSIGHT_PROCESS_SUCCESS,
                attrs: {
                    count: collections.length,
                },
            },
        }, collections);
        modal.open();
    },
};
//# sourceMappingURL=collection.insight.process.ctrl.js.map